import React from 'react'
import {
  Modal,
  Alert
} from 'antd'

interface PackingExportModalProps {
  visible: boolean
  onCancel: () => void
  onExport: () => Promise<void>
  selectedCount: number
}

const PackingExportModal: React.FC<PackingExportModalProps> = ({
  visible,
  onCancel,
  onExport,
  selectedCount
}) => {
  const handleExport = async () => {
    await onExport()
  }

  return (
    <Modal
      title="导出装箱数据"
      open={visible}
      onOk={handleExport}
      onCancel={onCancel}
      width={500}
      okText="导出"
      cancelText="取消"
    >
      <div>
        <Alert
          message="导出说明"
          description={
            <div>
              <p>将导出已选择的 <strong>{selectedCount}</strong> 个装箱清单的实际装箱数据</p>
              <p>导出格式参考装箱清单导入模板，每个清单一个工作表(Sheet)</p>
              <p>包含字段：PO订单号、款号、款名、箱号、颜色码、颜色描述、尺码、数量、净重、毛重等</p>
            </div>
          }
          type="info"
          showIcon
        />
      </div>
    </Modal>
  )
}

export default PackingExportModal